import { ProfilePicturePlaceholder } from "@snapchat/web-core-ui";
import { getClassName, Heading } from "@snapchat/web-sds-c";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { BlurredIconTile } from "../../../common/ImageTile/BlurredIconTile";
import { CreatorsLensTile } from "../CreatorsLensTile/CreatorsLensTile";
import styles from "./CreatorsTile.module.css";
import SnapStar from "./icons/SnapStar.svg";
export function CreatorsTile({ creatorDisplayInfo, hideCreatorName }) {
    const intl = useIntl();
    const alt = intl.formatMessage({
        defaultMessage: `Click to see Lenses and Filters created by {creatorName}`,
        description: "Alt text used on Creator tile on Lens Homepage",
    }, {
        creatorName: creatorDisplayInfo.name,
    });
    const renderProfilePicture = () => (<div className={clsx(styles.tileIconContainer, {
            [styles.tileIconWithStory]: creatorDisplayInfo.hasStory,
        })}>
      {creatorDisplayInfo.profilePicUrl ? (<img className={styles.tileIconPic} src={creatorDisplayInfo.profilePicUrl} alt={alt}/>) : (<div className={styles.tileIcon}>
          <ProfilePicturePlaceholder id={creatorDisplayInfo.id}/>
        </div>)}
    </div>);
    const iconUrls = [
        creatorDisplayInfo.lensPreviewInfos.at(0)?.iconUrl,
        creatorDisplayInfo.lensPreviewInfos.at(1)?.iconUrl,
        creatorDisplayInfo.lensPreviewInfos.at(2)?.iconUrl,
    ];
    const thumbnailUrls = [
        creatorDisplayInfo.lensPreviewInfos.at(0)?.thumbnailMediaUrl,
        creatorDisplayInfo.lensPreviewInfos.at(1)?.thumbnailMediaUrl,
        creatorDisplayInfo.lensPreviewInfos.at(2)?.thumbnailMediaUrl,
    ];
    const profilePicUrlOrDefault = creatorDisplayInfo.profilePicUrl
        ? creatorDisplayInfo.profilePicUrl
        : creatorDisplayInfo.lensPreviewInfos.at(0)?.iconUrl;
    const creatorsLensTile = () => {
        if (creatorDisplayInfo.lensPreviewInfos.length === 0) {
            // If user has a profile image url, we use that to form a blurred tile
            return creatorDisplayInfo.profilePicUrl ? (<span className={styles.blurredTileRadius}>
          <BlurredIconTile iconUrl={creatorDisplayInfo.profilePicUrl} iconBorder={true} size="small" alt={alt}/>
        </span>) : (
            // When the user does not have a profile image or any lens preview urls, we show a placeholder
            <div className={styles.placeholder}>
          <span className={getClassName("H4", true)}>
            <FormattedMessage description="Default text displayed on a Creators Tile." defaultMessage="No Lenses yet"/>
          </span>
        </div>);
        }
        else if (creatorDisplayInfo.lensPreviewInfos.length === 1) {
            return (<>
          <CreatorsLensTile lensIconUrl={profilePicUrlOrDefault} alt={alt} hideIconOverlay/>
          <CreatorsLensTile lensIconUrl={iconUrls[0]} thumbnailUrl={thumbnailUrls[0]} alt={alt} border/>
          <CreatorsLensTile lensIconUrl={profilePicUrlOrDefault} alt={alt} hideIconOverlay/>
        </>);
        }
        else if (creatorDisplayInfo.lensPreviewInfos.length === 2) {
            return (<>
          <CreatorsLensTile lensIconUrl={iconUrls[0]} thumbnailUrl={thumbnailUrls[0]} alt={alt}/>
          <CreatorsLensTile lensIconUrl={profilePicUrlOrDefault} alt={alt} hideIconOverlay border/>
          <CreatorsLensTile lensIconUrl={iconUrls[1]} thumbnailUrl={thumbnailUrls[1]} alt={alt}/>
        </>);
        }
        else {
            return (<>
          <CreatorsLensTile lensIconUrl={iconUrls[0]} thumbnailUrl={thumbnailUrls[0]} alt={alt}/>
          <CreatorsLensTile lensIconUrl={iconUrls[1]} thumbnailUrl={thumbnailUrls[1]} alt={alt} border/>
          <CreatorsLensTile lensIconUrl={iconUrls[2]} thumbnailUrl={thumbnailUrls[2]} alt={alt}/>
        </>);
        }
    };
    const userProfileUrl = `https://snapchat.com/add/${creatorDisplayInfo.username}`;
    return (<a className={styles.link} href={userProfileUrl} data-testid="lensCreatorLink">
      <div className={styles.container} data-testid="creatorsTile">
        <div className={styles.containerContent} data-testid="creatorsTileContent">
          <div className={styles.topContainer}>
            <div className={styles.iconContainer}>{renderProfilePicture()}</div>
            <div className={styles.description} data-testid="creatorsDescription">
              <div className={styles.descriptionContainer}>
                <div className={styles.creatorName}>
                  <span className={clsx(getClassName("H5", true), styles.creatorNameText)}>
                    {creatorDisplayInfo.name}
                  </span>
                  {creatorDisplayInfo.isOfficialCreator && (<div className={styles.snapStar}>
                      <SnapStar />
                    </div>)}
                </div>
                {!hideCreatorName && (<Heading size="H6">
                    <span className={styles.creatorUsername}>{creatorDisplayInfo.username}</span>
                  </Heading>)}
              </div>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <div className={styles.creatorLensTilesContainer}>{creatorsLensTile()}</div>
          </div>
        </div>
      </div>
    </a>);
}
